import { render, staticRenderFns } from "./OrganizacionesComunitariasView.vue?vue&type=template&id=16e34e94&"
import script from "./OrganizacionesComunitariasView.vue?vue&type=script&lang=ts&"
export * from "./OrganizacionesComunitariasView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports